import { useQuery } from "@apollo/client/react";
import { INVENTORY_REQUEST_QUERY, INTERNAL_WORK_ORDER_QUERY } from "src/constants/graphql/queries";

const queries = {
  internalWorkOrder: INTERNAL_WORK_ORDER_QUERY,
  inventoryRequest: INVENTORY_REQUEST_QUERY,
};

const responseKeys = {
  internalWorkOrder: "internalWorkOrder",
  inventoryRequest: "inventoryRequest",
};

const itemsKeys = {
  internalWorkOrder: "internalWorkOrderItems",
  inventoryRequest: "inventoryItems",
};

export default function useOrderData(id, orderType) {
  const query = queries[orderType];
  const { refetch } = useQuery(query, {
    variables: { id: id },
    skip: true,
  });

  const handleRefetch = async () => {
    const { data } = await refetch();
    const response = data[responseKeys[orderType]];

    return { ...response, items: response[itemsKeys[orderType]] };
  };

  return handleRefetch;
}
